import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Phone, Mail, Clock } from "lucide-react";
import SEO from "@/components/site/SEO";

const CARDS = [
  { icon: Phone, t: "Call Us", v: "(870) 919-9520" },
  { icon: Mail, t: "Email", v: "hello@hannahhowardfunding.com" },
  { icon: Clock, t: "Hours", v: "Mon–Sat, 8am–6pm" },
];

function ContactInfo() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-3 gap-6">
      {CARDS.map(({ icon: I, t, v }) => (
        <div key={t} className="lux-card p-8 text-center">
          <span className="w-12 h-12 rounded-2xl bg-[#F3D8DA] text-[#2A1C14] flex items-center justify-center mx-auto mb-4">
            <I size={22} strokeWidth={1.5} />
          </span>
          <p className="overline">{t}</p>
          <p className="font-serif-lux text-2xl mt-2">{v}</p>
        </div>
      ))}
    </section>
  );
}

const emptyForm = { full_name: "", email: "", phone: "", subject: "", message: "" };

function ContactForm() {
  const [form, setForm] = useState(emptyForm);
  const [submitting, setSubmitting] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      toast.success("Thanks — we'll reach out shortly.");
      setForm(emptyForm);
    } catch {
      toast.error("Something went wrong.");
    } finally { setSubmitting(false); }
  };

  return (
    <section className="max-w-3xl mx-auto px-6 pb-24">
      <form onSubmit={submit} className="lux-card p-8 sm:p-12 space-y-4" data-testid="contact-form">
        <Input required placeholder="Full Name" value={form.full_name} onChange={set("full_name")} data-testid="c-name"/>
        <Input required type="email" placeholder="Email" value={form.email} onChange={set("email")} data-testid="c-email"/>
        <Input required placeholder="Phone" value={form.phone} onChange={set("phone")} data-testid="c-phone"/>
        <Input required placeholder="Subject" value={form.subject} onChange={set("subject")} data-testid="c-subject"/>
        <Textarea required rows={6} placeholder="Message" value={form.message} onChange={set("message")} data-testid="c-message"/>
        <button disabled={submitting} className="btn-primary w-full justify-center" data-testid="c-submit">
          {submitting ? "Sending..." : "Submit"}
        </button>
      </form>
    </section>
  );
}

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <SEO
        title="Contact"
        description="Questions about a commission advance? Call, email, or send us a message — we get back to real estate agents fast."
        path="/contact"
      />
      <section className="gradient-champagne py-20 text-center">
        <span className="overline">Contact</span>
        <h1 className="font-serif-lux text-5xl sm:text-6xl mt-5 px-6">Let's Get Your <em className="italic text-[#5A3B31]">Commission</em> Moving</h1>
      </section>
      <ContactInfo />
      <ContactForm />
    </div>
  );
}
